import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { ExpensesCategoryDTO } from '../../expenses-category/dto/expenses-category.dto';
export class ExpensesSubCategoryDTO {
  @ApiProperty()
  @IsNotEmpty({message:"expensesSubCategoryId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  expensesSubCategoryId?: number;

  @ApiProperty()
  @IsNotEmpty({message:"expensesSubCategory should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  expensesSubCategory: string;

  @ApiProperty({ type: [ExpensesCategoryDTO]})
    expensesCategoryInfo: ExpensesCategoryDTO;

  @ApiProperty()
  @IsNotEmpty({message:"expensesCategoryId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  expensesCategoryId?: number;


  @ApiProperty()
  @IsNotEmpty({message:"expensesCategory should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  expensesCategory: string;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

